(function ($) {
  Drupal.behaviors.disableContinuar = {
    attach: function (context, settings) {
      let btnContinuarStep4 = document.querySelector('.step-4.btn-siguiente input');

      let requireFields = $('.js-form-item input[required="required"]');
      let emailFieldInput = $('.js-form-type-email input');
      let emailIsRequired = false;
      let emailIsCorrect = true;

      let nombreInput = $('.js-form-item-names input');
      let lastNameInput = $('.js-form-item-lastname input');
      let legalNameInput = $('.js-form-item-legal-name input');
      let celphoneNumberInput = $('.form-item-cellphone-number input');
      let addresInput = $(".js-form-item-address input");
      let checkedTicket = false;
      let correctSelects = true;
      let inputValue; // Declaring inputValue here

      function validateEmail(email) {
        var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return re.test(email);
      }

      function checkInputRadio() {
        checkedTicket = $('.js-form-item-digital-ticket input:checked').length > 0;
      }

      function checkEveryRequiredField() {
        let datosObligatoriosValid = true;

        $(requireFields).each(function () {
          let $input = $(this);
          if ($input.is(nombreInput) && $input.val() === '') {
            datosObligatoriosValid = false;
            return false; // Exit the loop early if any required field is empty
          } else if ($input.is(lastNameInput) && $input.val() === '') {
            datosObligatoriosValid = false;
            return false; // Exit the loop early if any required field is empty
          } else if ($input.is(celphoneNumberInput)) {
            let phoneNumber = $input.val();
            if (phoneNumber.length !== 10 || phoneNumber.substring(0, 1) !== "3") {
              datosObligatoriosValid = false;
              return false; // Exit the loop early if phone number is invalid
            }
          }
        });

        if (legalNameInput.length > 0 && legalNameInput.val() === '') {
          datosObligatoriosValid = false;
        }

        return datosObligatoriosValid;
      }

      function checkIfEmailIsCorrect() {
        let email = emailFieldInput.val().trim();
        emailIsCorrect = email === '' || validateEmail(email);

        if (emailFieldInput.hasClass('is-invalid') || (email === '' && emailIsRequired)) {
          emailIsCorrect = false;
        }
      }

      function enableBtnNext() {
        btnContinuarStep4.parentElement.classList.add('is-disabled');

        if (checkEveryRequiredField() && checkedTicket && correctSelects && emailIsCorrect) {
          btnContinuarStep4.parentElement.classList.remove('is-disabled');
        }
      }

      function checkLocationSelected() {
        let selectCiudad = $('.js-form-item-city select');

        $('.js-form-type-select select').each(function () {
          if (addresInput.val() !== '') {
            if ($(this).val() !== '' && selectCiudad.val() === 'Ciudad') {
              selectCiudad.parent().removeClass('is-valid');
              $(this).parent().removeClass('is-valid');
              correctSelects = false;
            }

            if ($(this).val() !== '' && selectCiudad.val() !== 'Ciudad') {
              selectCiudad.parent().addClass('is-valid');
              $(this).parent().addClass('is-valid');
              correctSelects = true;
            }
          }
        });
      }

      function delay(callback, ms) {
        var timer = 0;
        return function () {
          var context = this, args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
            callback.apply(context, args);
          }, ms || 0);
        };
      }

      if (btnContinuarStep4 !== null) {
        $(document).ready(() => {
          checkInputRadio();
          checkLocationSelected();
          checkIfEmailIsCorrect();
          enableBtnNext();
        });

        if (legalNameInput.length > 0) {
          legalNameInput.keypress(function (e) {
            let txt = String.fromCharCode(e.which);
            if (txt.match(/\:+/)) {
              e.preventDefault();
            }
          });

          legalNameInput.bind('paste', function () {
            setTimeout(function () {
              let value = legalNameInput.val();
              let updated = value.replace(/\:+/, "");
              legalNameInput.val(updated);
            });
          });
        }

        requireFields.keyup(delay(function () {
          checkEveryRequiredField();
          enableBtnNext();
        }, 300));

        emailFieldInput.keyup(delay(function () {
          checkIfEmailIsCorrect();
          enableBtnNext();
        }, 300));

        celphoneNumberInput.keyup(delay(function () {
          celphoneNumberInput.parent().addClass('invalid-number');
          if (celphoneNumberInput.val().substring(0, 1) == "3") {
            celphoneNumberInput.parent().removeClass('invalid-number');
          }
        }, 300));

        addresInput.keyup(delay(function () {
          if (addresInput.val() !== '') {
            correctSelects = false;
          } else {
            correctSelects = true;
          }

          checkLocationSelected();
          enableBtnNext();
        }, 300));

        $('.js-form-item-digital-ticket input').change((e) => {
          inputValue = e.target.value;
          if (inputValue == "1") {
            emailIsRequired = true;
          } else {
            emailIsRequired = false;
          }

          checkIfEmailIsCorrect();
          enableBtnNext();
        });

        $('.js-form-type-select select').on('change', () => {
          checkLocationSelected();
          enableBtnNext();
        });
      }
    },
  };
})(jQuery);
